import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ChevronLeft = function ChevronLeft(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86719 12.2441C4.86719 12.6953 5.03906 13.082 5.4043 13.4365L13.6436 21.4932C13.9336 21.7832 14.2773 21.9229 14.6855 21.9229C15.5234 21.9229 16.1895 21.2568 16.1895 20.4297C16.1895 20.0107 16.0176 19.6348 15.7168 19.3447L8.42285 12.2334L15.7168 5.14355C16.0283 4.84277 16.1895 4.4668 16.1895 4.05859C16.1895 3.23145 15.5234 2.56543 14.6855 2.56543C14.2773 2.56543 13.9336 2.70508 13.6436 2.99512L5.4043 11.0518C5.03906 11.4062 4.87793 11.7822 4.86719 12.2441Z"
  })));
};

ChevronLeft.displayName = 'ChevronLeft';
export default ChevronLeft;